<template>
  <button @click.stop="handleClick" class="btn-primary-sm">
    <font-awesome-icon v-if="icon" :icon="icon" />
    <span v-else>{{ label }}</span>
  </button>
</template>

<script>
export default {
  name: 'CellButton',
  props: {
    params: {
      type: Object,
      required: true,
    },
  },
  computed: {
    icon() {
      return this.params.icon
    },
    label() {
      return this.params.label || 'Click'
    },
  },
  methods: {
    handleClick() {
      if (this.params.onClick) {
        this.params.onClick(this.params.data)
      }
    },
  },
}
</script>
